import { all } from 'redux-saga/effects';
import { getAsyncSagas } from 'react-async-client';

export default function* () {
    yield all([
        ...getAsyncSagas()
    ]);
}
